import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Title from "../../components/Title";
import { CreateTwoTone, DeleteOutlineRounded } from "@material-ui/icons";
import FonctionService from "../../services/FonctionService";
import { DataGrid, GridToolbarContainer, GridToolbarExport } from '@material-ui/data-grid';
import Message from "../personnel/Message";
import Result from "../personnel/Result";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import { useNavigate } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  root: {
    padding: theme.spacing(0.5, 0.5, 0),
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  textField: {
    float: 'rigth',
    width: '20%',
  },
  select: {
    width: '20%',
  },
}));

export default function FonctionTable(props) {
  const navigate = useNavigate();
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [etat, setEtat] = useState({ open: false, message: "message", accept: false });
  const [etats, setEtats] = useState({ open: false, message: "message", color: "" });
  const [isid, setIsid] = useState(0);

  //Samuela: paramètrage pour le loader
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);

  const handleDelete = (id) => (ev) => {
    setEtat({
      open: true,
      message: "Voulez vous vraiment supprimer  ?"
    });
    setIsid(id);
  };

  function handleMessage() {
    setEtat({
      open: false,
      message: ""
    });
  }

  function handleAccept() {
    setEtat({
      open: false,
      message: "",
      accept: true
    });
    FonctionService.deleteFonction(isid).then((results) => {
      FonctionService.getfonction().then((result) => {
        if (result && result.data) {
          setRows(result.data.map((row) => ({ ...row, id: row.function_id })));
        }
      });
      if (results.status) {
        setEtats({ ...etats, open: true, color: 'green', message: results.message });
        navigate("/fonction");
      }
      else {
        setEtats({ ...etats, open: true, color: 'red', message: results.message });
      }
    });
  }

  const handleCloseMessage = () => {
    setEtats({ ...etats, open: false });
  };
  const handleEdit = (id) => (ev) => {
    navigate("/fonction/add/" + id);
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Intitulé',
      width: 350,
    },
    {
      field: 'code',
      headerName: 'Code ou sigle',
      width: 150,
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 250,
    },
    {
      field: 'action',
      headerName: 'Action',
      disableClickEventBulbing: true,
      renderCell: (params) => {
        return (
          <div>
            <Button onClick={handleEdit(params.id)} title="Modifier fonction"><CreateTwoTone style={{ color: "black" }} />
            </Button>
            <Button onClick={handleDelete(params.id)} title="Supprimer">
              <DeleteOutlineRounded style={{ color: "red" }} />
            </Button>
          </div>
        );
      },
      width: 200,
    },
  ];

  useEffect(() => {
    setOpenLoadingSimpleBackdrop(true);
    FonctionService.getfonction().then((result) => {
      if (result && result.data) {
        setRows(result.data.map((row) => ({ ...row, id: row.function_id })));
        setOpenLoadingSimpleBackdrop(false);
      } else {
        setOpenLoadingSimpleBackdrop(false);
      }
    });
  }, []);


  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  return (
    <React.Fragment>
      <Result message={etats.message} color={etats.color} open={etats.open} handleClose={handleCloseMessage} />
      <Message isActive={etat.open} message={etat.message} accept={etat.accept} handleClose={handleMessage} handleConfirm={handleAccept} />
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Title>Listes des Fonctions</Title>
      <div style={{ height: "70vh", width: '100%' }} className={classes.root}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={7}
          rowsPerPageOptions={[7]}
          disableSelectionOnClick
        />
      </div>
    </React.Fragment>
  );
}
